import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { ActionByBrand } from '../types/actionSchema';
import { FetchActionsByBrandDto } from './api.dto';

export const fetchActionByBrand = createAsyncThunk<ActionByBrand[], FetchActionsByBrandDto>(
  'actions/fetchActionByBrand',
  async ({ regionId, part, brand }) => {
    return await MyAxios.get(`/api/actions/get-by-brand?brand=${brand}&part=${part}&regionId=${regionId}`)
      .then(handleResponse)
      .catch(handleError);
  },
);
